module.exports = __webpack_public_path__ + "img/preset7.977a6e32.png";